import * as React from "react";
import moment from "moment";
import * as routes from "lib/routes";
import style from "./style.module.css";
import I18n from "lib/I18n";
import { convertBytesToReadable } from "lib/converter";
import { BsBoxArrowUpRight } from "react-icons/bs";
import { Stat } from "../../store";

interface TableProps {
  date: string;
  stats: Stat[];
}

export function Table(props: TableProps) {
  const { date, stats } = props;

  return (
    <table className="table tabpe-striped">
      <thead>
        <tr>
          <th className="nn-nowrap">
            {I18n.t("bigquery_query_jobs_stats_viewer.label.title")}
          </th>
          <th className="nn-nowrap">
            {I18n.t("bigquery_query_jobs_stats_viewer.label.cost")}
          </th>
          <th className="nn-nowrap">
            {I18n.t(
              "bigquery_query_jobs_stats_viewer.label.data_scanned_in_bytes",
            )}
          </th>
          <th className="nn-nowrap">
            {I18n.t("bigquery_query_jobs_stats_viewer.label.day")}
          </th>
        </tr>
      </thead>
      <tbody>
        {stats.map((stat, i) => {
          return (
            <tr key={i}>
              <td className="nn-nowrap">
                {stat.name}
                <a
                  target="_blank"
                  href={routes.title_bigquery_history_path(stat.id, "lp1", {
                    date: date,
                  })}
                  className={style.newWindow}
                  rel="noreferrer"
                >
                  <BsBoxArrowUpRight />
                </a>
              </td>
              <td className="nn-nowrap">{stat.cost.toPrecision(3)}</td>
              <td className="nn-nowrap">
                {convertBytesToReadable(stat.data_scanned_in_bytes)}
              </td>
              <td className="nn-nowrap">
                {moment(stat.date).format("YYYY-MM-DD ZZ")}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
